module.exports = __webpack_public_path__ + "static/x55-6e3f9ff2ab1aded62764be8ca38d7bf1.png";